import React from 'react';

import "./course.css"
import heroImg from "../../../images/hero-3.jpg"
import { Container } from 'react-bootstrap';
import SingleCourse from './SingleCourse';
import { MoreHoriz } from '@mui/icons-material';

const Courses = () => {
    return (
        <div id="course" >
            <div className="course-area course-area-02 pt-130 pb-100 blue-dark-bg2">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 offset-lg-3 offset-xl-3">
                            <div className="section-title section-title-white text-center mb-75">
                                <span><MoreHoriz /> Popular Courses <MoreHoriz /></span>
                                <h2>All Our courses </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row row-portfolio"  >
                        <SingleCourse />
                        <SingleCourse />
                        <SingleCourse />
                        <SingleCourse />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Courses;